module.exports = __webpack_public_path__ + "img/multiplier2_normal.2bd98ebc.png";